import { AppShell as AstryxAppShell, Button, TopNav } from "@astryxdesign/core";
import * as stylex from "@stylexjs/stylex";
import { LogOut, Truck, UserRound } from "lucide-react";
import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router";
import { useSession } from "@/services/auth0/session";

const styles = stylex.create({
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 600,
    color: "inherit",
    textDecoration: "none",
  },
  // Reproduces the previous max-w-2xl single-column content well.
  content: {
    width: "100%",
    maxWidth: "42rem",
    marginInline: "auto",
  },
  navActions: { display: "flex", alignItems: "center", gap: 4 },
});

export function AppShell({ children }: { children: ReactNode }) {
  const { logout, operator } = useSession();
  const navigate = useNavigate();
  return (
    <AstryxAppShell
      height="auto"
      contentPadding={4}
      mobileNav={false}
      topNav={
        <TopNav
          label="EZX Operator"
          heading={
            <Link to="/" {...stylex.props(styles.brand)}>
              <Truck size={20} />
              EZX Operator
            </Link>
          }
          endContent={
            <div {...stylex.props(styles.navActions)}>
              <Button
                variant="ghost"
                size="sm"
                icon={<UserRound size={16} />}
                label={operator?.carrierUser?.name || "Profile"}
                onClick={() => navigate("/profile")}
              />
              <Button
                variant="ghost"
                size="sm"
                icon={<LogOut size={16} />}
                label="Sign out"
                onClick={() => logout()}
              />
            </div>
          }
        />
      }
    >
      <div {...stylex.props(styles.content)}>{children}</div>
    </AstryxAppShell>
  );
}
